<script lang="ts">
export default {
  name: 'KkPostTitle',
}
</script>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useStore } from 'vuex'
import type { TopicType, Post } from '../../types'
import { KkValidationError } from '../../../../components/base'

const store = useStore()
const { t } = useI18n()

const post = computed<Post>(() => store.getters['companiesStorePosts/post'])

const updateTitleText = (topicType: TopicType, titleText: string): Promise<void> => store.dispatch(
  'companiesStorePosts/updateTitleText', {
    topicType,
    title: titleText
  }
)

const titleText = computed<string>({
  get: () => post.value.topicType === 'STANDARD' ? post.value.title ?? '' : post.value.event.title,
  set: (titleText: string) => {
    updateTitleText(post.value.topicType, titleText)
  }
})
const includesYahooMap = computed<boolean>(() => {
  return post.value.services.includes('yahoo_map')
})

const titleList = computed<Record<TopicType, string>>(() => {
  return {
    STANDARD: t('models.gmb.topicType.standard'),
    EVENT: t('models.gmb.topicType.event'),
    OFFER: t('models.gmb.topicType.offer'),
  }
})
const exampleList = computed<Record<TopicType, string>>(() => {
  return {
    STANDARD: t('pages.CompaniesStorePost.topicTypeExample.standard'),
    EVENT: t('pages.CompaniesStorePost.topicTypeExample.event'),
    OFFER: t('pages.CompaniesStorePost.topicTypeExample.offer'),
  }
})

const BASIC_MAX_LENGTH = 57
const YAHOO_MAP_MAX_LENGTH = 50
const YAHOO_MAP_MIN_LENGTH = 5
const maxLength = computed<number>(() => {
  return includesYahooMap.value ? YAHOO_MAP_MAX_LENGTH : BASIC_MAX_LENGTH
})
const requiredTitle = computed<boolean>(() => {
  if (includesYahooMap.value) return true
  if (post.value.topicType === 'EVENT' || post.value.topicType === 'OFFER') return true
  return false
})
const eventTitleRules = computed<string>(() => {
  let rules = `max:${maxLength.value}`
  if (includesYahooMap.value) rules += `|min:${YAHOO_MAP_MIN_LENGTH}`
  if (requiredTitle.value) rules = `required|${rules}`

  return rules
})
</script>
<template>
  <div>
    <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="titleText" :rules="eventTitleRules" :name="t('labels.titleOf', { value: titleList[post.topicType] })">
      <h4 class="label">{{ t('labels.titleOf', { value: titleList[post.topicType] }) }}({{ t('labels.countCharacters', { count: value ? value.length : 0, max: maxLength }) }}) {{ requiredTitle ? t('labels.requiredLabel') : t('labels.optionalLabel') }}</h4>
      <label>
        <input
          :value="value"
          type="text"
          class="c-textField"
          :maxlength="maxLength"
          @input="handleChange"
        >
      </label>

      <p class="example u-fsS">（例: {{ exampleList[post.topicType] }}）</p>
      <KkValidationError :text="errors[0]" />
    </ValidationProvider>
  </div>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.label {
  font-size: 12px;
  margin: 32px 0 8px;
}
.example {
  margin-top: 8px;
}
</style>
